import { WorksiteCreate } from "@wingspanhq/wingspan-api-sdk";

import { FormDataWorksite, WORKSITE_COUNTRY } from "../types";

/**
 * Maps the work site form onto the SDK payload. `WorksiteUpdate` is
 * `WorksiteCreate` with every field optional, so the create shape satisfies both
 * — an edit submits the full form anyway.
 *
 * Empty optional strings become `undefined` so we clear a value instead of
 * storing `""`.
 */
export const selectorWorksiteRequest = (
  formData: FormDataWorksite
): WorksiteCreate => ({
  name: formData.name,
  address: {
    line1: formData.address.addressLine1 || undefined,
    line2: formData.address.addressLine2 || undefined,
    city: formData.address.city || undefined,
    state: formData.address.state || undefined,
    postalCode: formData.address.postalCode || undefined,
    country: WORKSITE_COUNTRY
  },
  externalId: formData.externalId || undefined,
  isPrimary: formData.isPrimary
});
